export type ENVTYPE = 'dev' | 'test' | 'demo' | 'prod' | string;

export const tenantUsableFont = ['gongcha'];

export const __APP_ENV: ENVTYPE = process.env.NEXT_PUBLIC_APP_ENV || 'dev';

export const __API_URL_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'https://api-dev.peblla.top'],
  ['test', 'https://api-qa.pebla.us'],
  ['demo', 'https://api-demo.peblla.top'],
  ['prod', 'https://api.peblla.com']
]);

const __API_BITEME_URL: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'https://api.biteme-dev.ubtbus.top'],
  ['test', 'https://api-biteme-qa.peblla.top'],
  ['demo', 'https://api.biteme-demo.ubtbus.top'],
  ['prod', 'https://api-biteme.peblla.com']
]);

export const __APP_ID_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', '680457596783557120'],
  ['test', '720300629561440768'],
  ['demo', '720300651770280448'],
  ['prod', '733690175993063936']
]);

export const __RESERVATION_MAP_KEY_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'AIzaSyCdeejcWorWG7ewtlN4lNlhTXo6IguNrTQ'],
  ['test', 'AIzaSyCdeejcWorWG7ewtlN4lNlhTXo6IguNrTQ'],
  ['demo', 'AIzaSyCdeejcWorWG7ewtlN4lNlhTXo6IguNrTQ'],
  ['prod', 'AIzaSyAxZnHDSrvft1ATaF6pmsdQHjROtmtHR4w']
]);

export const __SERVE_BASEURL_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'http://172.17.57.142:9500'],
  ['test', 'http://platform-alaeat.peblla:8080'],
  ['demo', 'http://platform-alaeat.peblla:8080'],
  ['prod', 'http://platform-alaeat.peblla:8080']
]);

export const __BITEME_INSTANCE_ID_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', '627198693203769856'],
  ['test', '725044828273900032'],
  ['demo', '635114899550239232'],
  ['prod', '726812443325677056']
]);

export const __BITEME_TID_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', '481092132283617792'],
  ['test', '491279683002843648'],
  ['demo', '491279683002843648'],
  ['prod', '491279683002843648']
]);

// peblla domain
export const __PEBBLA_DOMAIN_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'order-dev.peblla.top'],
  ['test', 'order-test.peblla.top'],
  ['demo', 'order-demo.peblla.top'],
  ['prod', 'order.peblla.com']
]);

export const __PEBBLA_TABLE_DOMAIN_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', 'table-dev.peblla.top'],
  ['test', 'table-test.peblla.top'],
  ['demo', 'table-demo.peblla.top'],
  ['prod', 'table.peblla.com']
]);

export const __BITEME_ALLIANCE_ID_MAP: ReadonlyMap<ENVTYPE, string> = new Map([
  ['dev', '1120285015247159872'],
  ['test', '1122488768977331712'],
  ['demo', '1125157436815076288'],
  ['prod', '1127279632809671424']
]);

export const __BITEME_ALLIANCE_ID = __BITEME_ALLIANCE_ID_MAP.get(__APP_ENV) as string;

export const __PEBBLA_TABLE_DOMAIN = __PEBBLA_TABLE_DOMAIN_MAP.get(__APP_ENV) as string;

export const __PEBBLA_DOMAIN = __PEBBLA_DOMAIN_MAP.get(__APP_ENV) as string;

export const __BITEME_INSTANCE_ID = __BITEME_INSTANCE_ID_MAP.get(__APP_ENV) as string;
export const __BITEME_TID = __BITEME_TID_MAP.get(__APP_ENV) as string;


export const __APP_ID = __APP_ID_MAP.get(__APP_ENV) as string;

export const ___API_BASE_URL = __API_URL_MAP.get(__APP_ENV);
export const ___API_SERVE_BASE_URL = __SERVE_BASEURL_MAP.get(__APP_ENV);
 
export const ___API_BITEME_URL = __API_BITEME_URL.get(__APP_ENV);

export const __RESERVATION_MAP_KEY = __RESERVATION_MAP_KEY_MAP.get(__APP_ENV);


export const localRunDomain: any = {}